import { Button, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import styles from "./Popup.module.css";
import axios from "axios";
import { forwardRef, useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { authData } from "../../components/GetAuth";
import { Close } from "@mui/icons-material";
import { Check, X } from "react-feather";

const CustomInput = forwardRef((props, ref) => (<TextField {...props} inputRef={ref} id="outlined-basic" label="Amount(&pound;)*" variant="outlined" fullWidth />));

const AddDeliveryProductForm = ({ setFormOpen, setAllData, setSnackbarOpen, setSnackbarMessage, setSnackbarType, setLoading, editData }) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [parentList, setParentList] = useState([]);
  const { register, handleSubmit, control, setValue, formState: { errors } } = useForm({
    mode: "onChange",
    defaultValues: {
      title: "",
      parent_id: "",
      amount: "",
    },
  });

  useEffect(() => {
    const fetchCategory = () => {
      axios.get(process.env.REACT_APP_API_URL + "v1/delivery-category-list", {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        let itemData = response.data.data;
        itemData = [{ value: 0, label: "No Category" }].concat(itemData);
        setParentList(itemData);
      }).catch((error) => { });
    };

    fetchCategory();
  }, [API_TOKEN]);

  useEffect(() => {
    if (editData) {
      setValue("title", editData?.title);
      setValue("amount", editData?.amount);
      setValue("parent_id", editData?.parent_id);
    }
  }, [editData, setValue]);

  const onSubmit = (data) => {
    setLoading(true);
    setFormOpen(false);
    if (editData) {
      axios.post(process.env.REACT_APP_API_URL + "v1/delivery-products/" + editData?.id, data, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          setAllData((prev) => {
            let temp = prev.map((i) => {
              if (i.id === editData?.id) {
                return response.data.data;
              }
              return i;
            });
            return temp;
          });
        }
        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    } else {
      axios.post(process.env.REACT_APP_API_URL + "v1/delivery-products", data, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          setAllData((prev) => {
            return [response.data.data].concat(prev);
          });
        }
        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    }
  };

  return (<>
    <DialogTitle id="alert-dialog-title" className={`${styles.PopupTitleBar}`}>
      {editData ? "Update Delivery Product" : "Add Delivery Product"}
      <IconButton onClick={(e) => setFormOpen(false)} className={`${styles.PopupCloseBU}`} aria-label="Close"><Close /></IconButton>
    </DialogTitle>
    <DialogContent className={`${styles.PopupContent}`}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={`${styles.FormMainRow}`}>
          <div className={`${styles.FormGroupHalf}`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Category*</InputLabel>
              <Controller
                control={control}
                {...register("parent_id", { required: "This field is Required" })}
                render={({ field }) => (
                  <Select {...field} label="Category?*">
                    {parentList?.map((val) => {
                      return (<MenuItem key={val?.value} value={val?.value}>
                        {val?.label}
                      </MenuItem>);
                    })}
                  </Select>
                )}
              />
            </FormControl>
          </div>
          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              control={control}
              {...register("title", { required: "This field is Required" })}
              render={({ field }) => (<TextField {...field} label="Title*" variant="outlined" fullWidth />)}
            />
            {errors.title && (<span className={`${styles.ErrorM}`}>{errors?.title?.message}</span>)}
          </div>
          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              control={control}
              {...register("amount", { required: "This field is Required" })}
              render={({ field }) => (<NumericFormat {...field} customInput={CustomInput} decimalScale={2} />)}
            />

            {errors.amount && (<span className={`${styles.ErrorM}`}>{errors?.amount?.message}</span>)}
          </div>
        </div>
        <div className={`${styles.ButtonAction}`}>
          <Button className={`${styles.CancelPopupBU}`} startIcon={<X size={16} />} onClick={(e) => setFormOpen(false)}>Cancel</Button>
          <Button className={`${styles.SubmitPopupBU}`} startIcon={<Check size={16} />} type="submit">{editData ? "Update" : "Add"}</Button>
        </div>
      </form>
    </DialogContent>
  </>);
};

export default AddDeliveryProductForm;